import { render } from "./SummaryCommentForm.vue?vue&type=template&id=5909662c"
import script from "./SummaryCommentForm.vue?vue&type=script&lang=js"
export * from "./SummaryCommentForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__